import { Link, Text } from "basis";
import { usePageTracking, useEventTracking } from "react-event-tracker";
import { getSelfHref, usePersonalLoanAccount } from "library/accounts";
import { useProducts } from "library/hooks/useProducts";
import { Layout } from "../Layout/Layout";
import { PersonalLoanAccountSummary } from "../PersonalLoanAccountSummary/PersonalLoanAccountSummary";
import { Loading } from "../Loading/Loading";

const PersonalLoanAccountComponent = ({
  product,
  accountClosed,
  isNormalPayment,
  isFinalPayment,
  accountInfo,
}) => {
  const { trackEvent, getQueryString } = useEventTracking();
  return (
    <>
      <PersonalLoanAccountSummary account={accountInfo.data} />
      <Text margin="4 0 0 0" textStyle="body2">
        {isNormalPayment && !accountClosed && !isFinalPayment && (
          <>
            * This amount does not include any monthly repayments that may be
            overdue.
            <br />
          </>
        )}
        <Link
          onClick={() => {
            trackEvent({
              event: {
                category: "text-link",
                action: "internal-link",
                location: "Account details",
                label: "View our Personal Loan rates, fees and charges.",
              },
            });
          }}
          href={`${product.url}/${getQueryString({
            event: {
              category: "text-link",
              action: "internal-link",
              location: "Account details",
              label: "View our Personal Loan rates, fees and charges.",
            },
          })}`}
          newTab
        >
          View our Personal Loan rates, fees and charges.
        </Link>
      </Text>
    </>
  );
};

export const PersonalLoanAccount = (props) => {
  const { state } = props.location;
  usePageTracking({
    page: {
      pageType: "details-page",
      siteSection: "accounts",
      siteSubSection: "personal-loan",
      pageTitle: "product-details",
    },
    user: {
      authenticationStatus: "logged in",
    },
    productId: [state.account.product_id],
  });
  const productsInfo = useProducts();
  const href = getSelfHref(state.account);
  const accountInfo = usePersonalLoanAccount({
    accountId: state.account.account_id,
    enabled: href !== undefined,
  });

  if (accountInfo.isLoading || productsInfo.isLoading) {
    return <Loading />;
  }

  if (accountInfo.isError || productsInfo.isError) {
    return <Text>Failed to load.</Text>;
  }

  const account = accountInfo.data;
  const { accountClosed, isNormalPayment, isFinalPayment } = account;
  const product =
    productsInfo.data.find((p) => p.product_id === account.product_id) || {};

  return (
    <Layout>
      <Layout.Header>Account details</Layout.Header>
      <Layout.Main>
        <PersonalLoanAccountComponent
          {...{
            product,
            accountClosed,
            isNormalPayment,
            isFinalPayment,
            accountInfo,
          }}
        />
      </Layout.Main>
    </Layout>
  );
};
